import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebase'; // Adjust path

const AddEmployeePage = () => {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState('Designer'); // Default role
    const [whatsappNumber, setWhatsappNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Define available roles (sync with your system's roles)
    const availableRoles = [
        "Manager", "Sales Manager", "Sales", "Accounts Manager", "Designer",
        "Photographer", "Marketer", "HR", "Content Creator", "Freelancer"
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        // Basic password validation (add more robust validation)
        if (password.length < 6) {
            setError("Password should be at least 6 characters long.");
            setLoading(false);
            return;
        }

        try {
            // 1. Create user in Firebase Authentication
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // 2. Create user document in Firestore
            const userDocRef = doc(db, 'users', user.uid);
            await setDoc(userDocRef, {
                name: name,
                email: email,
                role: role,
                ...(whatsappNumber.trim() && { whatsappNumber: whatsappNumber.trim() }),
                createdAt: serverTimestamp()
                // DO NOT store password here
            });

            console.log("Employee added successfully:", user.uid);
            navigate('/employees'); // Redirect to employee list

        } catch (err) {
            console.error("Error adding employee:", err);
            // Provide more specific error messages based on err.code
            if (err.code === 'auth/email-already-in-use') {
                setError('This email address is already registered.');
            } else if (err.code === 'auth/weak-password') {
                 setError('The password is too weak.');
            }
            else {
                setError('Failed to add employee. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2>Add New Employee</h2>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="name">Full Name:</label>
                    <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} required />
                </div>
                <div>
                    <label htmlFor="email">Email:</label>
                    <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                 <div>
                    <label htmlFor="password">Password:</label>
                    <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    <small>Minimum 6 characters</small>
                </div>
                 <div>
                    <label htmlFor="role">Role:</label>
                    <select id="role" value={role} onChange={(e) => setRole(e.target.value)} required>
                        {availableRoles.map(r => (
                            <option key={r} value={r}>{r}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label htmlFor="whatsapp">WhatsApp Number (optional):</label>
                    <input
                        type="tel"
                        id="whatsapp"
                        value={whatsappNumber}
                        onChange={(e) => setWhatsappNumber(e.target.value)}
                        placeholder="e.g. +970501234567"
                    />
                    <small>Format: +[country code][number]</small>
                </div>
                <button type="submit" disabled={loading}>
                    {loading ? 'Adding...' : 'Add Employee'}
                </button>
            </form>
             {/* --- TODO: Add Styling --- */}
        </div>
    );
};

export default AddEmployeePage;